// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import { Helmet } from 'react-helmet';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { useTranslation } from 'react-i18next';

import AccountSideMenu from 'Containers/AccountSideMenu/AccountSideMenu';
import Offers from 'Containers/Offers/Offers';

const StyledOffersPage = styled.div`
  display: grid;
  grid-column-gap: 30px;
  grid-template-columns: 260px minmax(0, 1fr);

  @media screen and (max-width: 1024px) {
    grid-template-columns: minmax(0, 1fr);

    aside {
      display: none;
    }
  }
`;

const OffersPage = memo(() => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, interactive-widget=resizes-content"
        />
        <title>{ t('offers.myOffers') }</title>
        <body className="OffersPage" />
      </Helmet>
      <StyledOffersPage className="grid-container" theme={ theme }>
        <AccountSideMenu />
        <Offers />
      </StyledOffersPage>
    </>
  );
});

OffersPage.displayName = 'OffersPage';

export default OffersPage;
